import { render, staticRenderFns } from "./History.svg.vue?vue&type=template&id=79e99170"
import script from "./History.svg.vue?vue&type=script&lang=ts"
export * from "./History.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e99170')) {
      api.createRecord('79e99170', component.options)
    } else {
      api.reload('79e99170', component.options)
    }
    module.hot.accept("./History.svg.vue?vue&type=template&id=79e99170", function () {
      api.rerender('79e99170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/History.svg.vue"
export default component.exports